import { PAY_CYCLE, type Period, type Account, type Company,
  GENDER,
  EMPLOYMENT_STATUS,
  SALARY_SCHEME,
  SALARY_CALCULATION,
  MARITAL_STATUS,
  HOLIDAY_TYPE,
  LEAVE_TYPE,
  DAY_TYPE,
  ACCOUNT_TYPE,
  ACCOUNT_SIDE,
  SUPERVISOR_ALLOWANCE_CALC,
  STAT_CALC_TYPE,
} from './types'
import { ref, computed, reactive, unref } from 'vue'
import { defineStore } from 'pinia'
import dayjs from 'dayjs'
import { config } from '@/config'
// import { useEmployeeStore } from './employee'
// import { usePeriodStore } from './period'

export const useAppStore = defineStore('app', () => {
  // app Setting / Config
  const options = ref({
    companyEnabled: config.enableCompany,
    costEnabled: config.enableCost
  })

  const SalarySchemes = Object.values({ ...SALARY_SCHEME })
  const SalaryCalculations = Object.values({ ...SALARY_CALCULATION })
  const MaritalStatuses = Object.values({ ...MARITAL_STATUS })
  const PayCycles = Object.values({ ...PAY_CYCLE })
  const EmploymentStatuses = Object.values({ ...EMPLOYMENT_STATUS })
  const Genders = Object.values({...GENDER})
  const AccountSides = Object.values({...ACCOUNT_SIDE})
  const AccountTypes = Object.values({...ACCOUNT_TYPE})
  const HolidayTypes = Object.values({...HOLIDAY_TYPE})
  const LeaveTypes = Object.values({...LEAVE_TYPE})
  const DayTypes = Object.values({...DAY_TYPE})
  const SupervisorAllowanceCalc = Object.values({...SUPERVISOR_ALLOWANCE_CALC})

  // const periodStore = usePeriodStore()

  const errors = ref({} as any)
  const leftSidebar = ref(true)
  const rightSidebar = ref(true)
  const isLoading = ref(false)
  const isPrinting = ref(false)

  const uploadFile = ref(['dailytime', 'transact','employee','cost','company','table'])
  const generatePeriod = ref(['period'])
  const generateAccount = ref(['account'])
  const generateEmployee = ref(['employee'])


  const globalFilter = ref({
    payCycle: ['period','employee','payslip','dailytime','preview'],
    date: ['dailytime', 'transact'],
    period: ['payslip', 'dailytime', 'earning', 'deduction', 'transact','preview'],
    account: ['transact'],
    company: ['dailytime'],
    year: ['period','payslip', 'dailytime', 'earning', 'deduction', 'transact','preview'],
  })

  const uploadFilter = ref({
    'deduction': ['1010','2010','2020','2030','2040'],
    'earning': ['1000','1010','1020','1030']
  })

  const takesLonger = ref(['period','dailytime','deduction','earning','payslip'])

  const payFactor = ref({
    RH: 2.0, //regular holiday
    NP: 0.1,  //night premium
    SH: 1.0, //special holiday
    NH: 1.0, //non-working holiday (worked) — missing entry made basic salary NaN
    RD: 1.0, //rest day
    OT: 1.0, //overtime
    // SH: 1.3, //special holiday
    // RD: 1.3, //rest day 
  })

  const paySetting = ref({
    daysInYear: 314,
    hoursInDay: 8,
    breakHours: 1,
    halfSaturday: true,

    // in minutes
    undertimeAllowance: 15,
    minimumOvertime: 30, 

    allowTimeOffset: false, // early in or late out to compensate
  })

  const thisPayCycle = ref(Object.values(PAY_CYCLE)[1])
  const thisYear = ref(dayjs().year())
  const thisPeriod = ref({} as Period)
  const thisAccount = ref({} as Account)
  const thisCompany = ref({} as Company)
  const reportEmployee = ref('all') // employee sheet picked in a report preview ('all' = every employee)

  const thisStartDate = ref(dayjs().startOf('year').toDate())
  const thisEndDate = ref(dayjs().endOf('year').toDate())

  const periodLabel = computed(()=> {
    return '(' + thisPayCycle.value + ': ' + dayjs(thisPeriod.value['start_date']).format('MM/DD/YYYY') + ' - ' + dayjs(thisPeriod.value['end_date']).format('MM/DD/YYYY') +  ')'
  })
  
  return {
    errors,
    leftSidebar,
    rightSidebar,
    uploadFile,
    
    generateAccount,
    generatePeriod,
    generateEmployee,

    globalFilter,
    uploadFilter,

    options,
    payFactor,
    paySetting,

    thisPayCycle,
    thisYear,
    thisStartDate,
    thisEndDate,
    thisPeriod,
    thisCompany,
    thisAccount,
    reportEmployee,

    isLoading,
    isPrinting,
    takesLonger,

    SalarySchemes,
    SalaryCalculations,
    MaritalStatuses,
    PayCycles,
    EmploymentStatuses,
    Genders,
    AccountTypes,
    AccountSides,
    HolidayTypes,
    LeaveTypes,
    DayTypes,
    SupervisorAllowanceCalc,

    periodLabel,
  
  }
})
